(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/filter-and-sort/assets/javascripts/components/sort-option.js') >= 0) return;  svs.modules.push('/components/casino-react/filter-and-sort/assets/javascripts/components/sort-option.js');

'use strict';

const {
  Radio
} = svs.ui.ReactForm;
const SortOption = _ref => {
  let {
    sortingOption,
    isChecked,
    onClickCallback
  } = _ref;
  const handleClick = event => {
    event.stopPropagation();
    onClickCallback(sortingOption);
  };
  return React.createElement("li", {
    className: "sort-option"
  }, React.createElement(Radio, {
    branding: "inverted",
    checked: isChecked,
    name: sortingOption.name,
    onChange: handleClick,
    value: sortingOption.mode
  }, sortingOption.name));
};
setGlobal('svs.components.casino_react.filterAndSort.components.SortOption', SortOption);

 })(window);